<template>
  <div class="calendar_box">
    <!-------------------------------------------------------------------------------------------------------------------->
    <div class="week">
      <ul class="week_ul">
        <li class="week_li">
          <p class="week_p">一</p>
          <p class="week_p">MON</p>
        </li>
        <li class="week_li">
          <p class="week_p">二</p>
          <p class="week_p">TUE</p>
        </li>
        <li class="week_li">
          <p class="week_p">三</p>
          <p class="week_p">WED</p>
        </li>
        <li class="week_li">
          <p class="week_p">四</p>
          <p class="week_p">THU</p>
        </li>
        <li class="week_li">
          <p class="week_p">五</p>
          <p class="week_p">FRI</p>
        </li>
        <li class="week_li">
          <p class="week_p">六</p>
          <p class="week_p">SAT</p>
        </li>
        <li class="week_li">
          <p class="week_p">日</p>
          <p class="week_p">SUN</p>
        </li>
      </ul>
    </div>
    <div class="date" v-if="closeDateObj.close_date_list">
      <ul class="date_ul">
        <li
          class="date_li"
          v-for="(item,index) in firstWeekArr"
          :key="'up'+index"
          @click="getThisDate(item.thisdate,item.indexval)"
          :class="{date_act:item.hownumber == todayDate,no_select:openLaterSeven.indexOf(item.hownumber) == -1 || item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1,selected_act:selectedDate == item.thisdate}"
        >
          <p class="date_p">{{item.hownumber}}</p>
          <p class="date_p date_p_text" v-if="item.hownumber == todayDate && language == 2">Today</p>
          <p class="date_p date_p_text" v-if="item.hownumber == todayDate && language == 1">今天</p>
          <p class="date_p date_p_text" v-if="item.hownumber == todayDate && language == 3">དེ་རིང་།</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 1"
          >闭馆</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 2"
          >Closed</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 3"
          >སྒོ་རྒྱག</p>
          <!--<p class="date_p date_p_text" v-if="item.hownumber !== todayDate && item.indexval !== closeindex && closeDateObj.close_date_list.indexOf(item.thisdate) == -1">可预约</p>-->
        </li>
      </ul>
      <ul class="date_ul">
        <li
          class="date_li"
          v-for="(item,index) in secondWeekArr"
          :key="'down'+index"
          @click="getThisDate(item.thisdate,item.indexval)"
          :class="{no_select:openLaterSeven.indexOf(item.hownumber) == -1 || item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1,selected_act:selectedDate == item.thisdate}"
        >
          <p class="date_p">{{item.hownumber}}</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 1 && item.hownumber != todayDate"
          >闭馆</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 2 && item.hownumber != todayDate"
          >Closed</p>
          <p
            class="date_p date_p_text"
            v-if="(item.indexval == closeindex || closeDateObj.close_date_list.indexOf(item.thisdate) !== -1) && language == 3 && item.hownumber != todayDate"
          >སྒོ་རྒྱག</p>
          <!--<p class="date_p date_p_text" v-else>可预约</p>-->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
/** @format */

export default {
    props: ['closeDateObj'],
    data () {
        return {
            firstWeekArr: [],
            secondWeekArr: [],
            todayDate: null,
            closeindex: 0, // 星期三闭馆
            //				closeDateObj.close_date_list:['2018-10-31','2018-11-2'],//闭馆日
            openLaterSeven: [], // 今天之后的七天才有机会预约
            language: localStorage.language,
            selectedDate: ''
        }
    },
    mounted () {},
    watch: {
        closeDateObj (newVal, oldVal) {
            this.closeindex = this.closeDateObj.per_week_close_date - 1
            this.init(this.closeDateObj.current_time * 1000)
        }
    },
    methods: {
        init (current_time) {
            const v = this
            var everydayInfor = {} // 存放某一天的日期，如：2018-10-27,星期的所引值0~6,以及多少号：如今天是2018-10-27取27
            var todaydate = new Date(current_time) // 获取今天的日期
            var todayweekval = todaydate.getDate() // 返回今天是多少号
            v.todayDate = todayweekval
            var weekindex = todaydate.getDay() // 返回今天是周几的索引值
            everydayInfor = v.getOneDayInforObject(
                v.getOneDayDate(0, current_time),
                weekindex - 1,
                todayweekval
            )
            var todaydatearr = [everydayInfor] // 把今天的日期单独放到一个数组里
            // 获取今天之后七天的日期数组
            var sevendayarr = []
            for (let i = 1; i < 8; i++) {
                var todaydate = new Date(current_time) // 获取今天的日期
                todaydate.setDate(todayweekval + i)
                sevendayarr.push(todaydate.getDate())
            }
            v.openLaterSeven = sevendayarr
            // 获取今天之前的星期的日期数组
            var todaybeforearr = []
            var beforearrnum = weekindex == 0 ? 6 : weekindex - 1 // 今天之前的星期有几天
            for (let i = beforearrnum; i > 0; i--) {
                var todaydate = new Date(current_time) // 获取今天的日期
                todaydate.setDate(todayweekval - i) // 获取今天前i天的日期
                todaybeforearr.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(-i, current_time),
                        beforearrnum - i,
                        todaydate.getDate()
                    )
                ) // push到日期数组里
            }
            // 获取今天之后的星期的日期数组
            var todaylater = []
            var laterarrnum = weekindex == 0 ? 0 : 7 - weekindex // 获取本周结束剩余的天数
            for (let i = laterarrnum; i > 0; i--) {
                var todaydate = new Date(current_time) // 获取今天的日期
                todaydate.setDate(todayweekval + laterarrnum - i + 1) // 获取今天后i天的日期
                todaylater.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(laterarrnum - i + 1, current_time),
                        7 - i,
                        todaydate.getDate()
                    )
                )
            }
            this.firstWeekArr = [...todaybeforearr, ...todaydatearr, ...todaylater]
            // 获取本周的下一周日期数组
            var nextweekarr = []
            for (let i = 1; i < 8; i++) {
                var todaydate = new Date(current_time) // 获取今天的日期
                todaydate.setDate(todayweekval + i + laterarrnum)
                nextweekarr.push(
                    v.getOneDayInforObject(
                        v.getOneDayDate(i + laterarrnum, current_time),
                        i - 1,
                        todaydate.getDate()
                    )
                )
            }
            this.secondWeekArr = nextweekarr
        },
        // 返回当前日期之前或之后某一天的日期,负值表示之前，正值表示之后
        getOneDayDate (val, current_time) {
            var mydate = new Date(current_time)
            mydate.setDate(mydate.getDate() + val) // 获取val天后的日期
            var y = mydate.getFullYear()
            var m = mydate.getMonth() + 1 // 获取当前月份的日期
            if (m < 10) {
                m = '0' + m
            }
            var d = mydate.getDate()
            if (d < 10) {
                d = '0' + d
            }
            return y + '-' + m + '-' + d
        },
        // 返回日期信息对象
        getOneDayInforObject (date, index, number) {
            var obj = {}
            obj.thisdate = date
            obj.indexval = index
            obj.hownumber = number
            return obj
        },
        getThisDate (val, val2) {
            var weekday = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            localStorage.weekVal = weekday[val2]
            this.selectedDate = val
            this.$emit('currentIndex', val)
        }
    }
}
</script>
<style lang="scss" scoped>
/** @format */

.calendar_box {
  width: 854px;
  margin: 10px auto;
}

.week_ul {
  overflow: hidden;
}

.week_li {
  width: 112px;
  height: 70px;
  background: #ad011b;
  float: left;
  margin: 0 5px;
}

.week_p {
  line-height: 35px;
  font-size: 18px;
  color: #fff;
  text-align: center;
}
/*-----------------------------------------*/

.date {
  width: 100%;
  min-height: 100px;
}

.date_ul {
  overflow: hidden;
  border-top: 2px solid #e5e5e5;
}

.date_ul:first-child {
  margin-top: 40px;
}

.date_ul:last-child {
  border-bottom: 2px solid #e5e5e5;
}

.date .date_li {
  width: 112px;
  height: 70px;
  margin: 10px 5px;
  float: left;
  cursor: pointer;
}
.date .selected_act {
  border: 0;
  background: #edaa42;
}
.date .no_select {
  pointer-events: none;
}

.date .date_act {
  width: 108px;
  height: 66px;
  border: 2px solid #edaa42;
}

.date_p {
  line-height: 35px;
  font-size: 18px;
  color: #55555a;
  text-align: center;
}

.date .date_act .date_p {
  line-height: 33px;
}

.date .no_select .date_p,
.date .no_select .date_p_text {
  color: #a1a1a1;
}
.date .selected_act .date_p {
  color: #fff;
}
.date .date_act .date_p_text {
  color: #edaa42;
}
/*--------------------页面其它样式---------------------------------*/
</style>



// WEBPACK FOOTER //
// src/components/calendarmodule.vue